// extracted by mini-css-extract-plugin
export default {"cautionBox":"w7-z"};